import { render, staticRenderFns } from "./PsychologistsList.vue?vue&type=template&id=6ef2539f"
import script from "./PsychologistsList.vue?vue&type=script&lang=js"
export * from "./PsychologistsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports